import React from 'react';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'

const Header = () => {
    return (
        <div>
            <h1 className="bg-info p-5 text-center mb-0 container">Bangladeshi Cricket Players</h1>
        </div>
    );
};

export default Header;